import { render, staticRenderFns } from "./park.vue?vue&type=template&id=2bb273e4"
import script from "./park.vue?vue&type=script&lang=js"
export * from "./park.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports